import { getStatusForId as getStatus } from '@ms/yammer-data-support';

import { DismissablePrompt, DismissablePromptKey, EntityStatus, YammerState } from '../../state/types';
import { createFindById } from '../findById';

export const findById = createFindById<DismissablePrompt>('dismissablePrompts');

type GetStatusForId = (state: YammerState, id: DismissablePrompt['id']) => EntityStatus;
export const getStatusForId: GetStatusForId = (state, id) => getStatus(state.dismissablePrompts, id);

type FindFirstUndismissedPrompt = (
  state: YammerState,
  keys: DismissablePromptKey[]
) => DismissablePromptKey | undefined;
export const findFirstUndismissedPromptKey: FindFirstUndismissedPrompt = (state, keys) =>
  keys.find((key) => {
    const prompt = findById(state, key);

    return prompt && !prompt.isDismissed;
  });

type IsPromptDismissed = (state: YammerState, id: DismissablePrompt['id']) => boolean;
export const isPromptDismissed: IsPromptDismissed = (state, id) => {
  const prompt = findById(state, id);

  return (prompt && prompt.isDismissed) || false;
};
